import { ContentGravity } from '@next-space/fe-api-idl';
import isHotkey from 'is-hotkey';
import { useCallback } from 'react';
import { useAlignBlock } from 'src/hooks/block/use-align-block';
import { useTransaction } from 'src/hooks/use-transaction';
import { cache } from 'src/redux/store';
import { getAlignBlockIds } from 'src/utils/block-utils';
/** 对齐快捷键 */
export const useAlignKey = () => {
  const { alignBlock } = useAlignBlock();
  const transaction = useTransaction();
  const alignKey = (e: KeyboardEvent) => {
    if (isHotkey(['l', 'c', 'r'])(e)) {
      const alignBlockIds = getAlignBlockIds(cache.ui.selectedBlocks);
      if (alignBlockIds.length === 0) return;
      let gravity = ContentGravity.LEFT;
      switch (true) {
        case isHotkey('l')(e): {
          gravity = ContentGravity.LEFT;
          break;
        }
        case isHotkey('c')(e): {
          gravity = ContentGravity.CENTER;
          break;
        }
        case isHotkey('r')(e): {
          gravity = ContentGravity.RIGHT;
          break;
        }
        default:
      }
      transaction(() => {
        alignBlockIds.forEach((id) => {
          alignBlock(id, gravity);
        });
      });
    }
  };
  return useCallback(alignKey, [alignBlock, transaction]);
};
